
function getTodayDateDMY() {
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const yyyy = today.getFullYear();
    return `${dd}-${mm}-${yyyy}`;
}

function getFinancialYearDateDMY() {
    const today = new Date();
    const fixedDay = '01';
    const fixedMonth = '04'; // For example, April

    const currentMonth = today.getMonth() + 1;

    let yyyy = today.getFullYear();

    if (currentMonth < 4) {
        yyyy = yyyy - 1;
    }

    return `${fixedDay}-${fixedMonth}-${yyyy}`;
}

function getTodayDateYMD() {

    const today = new Date();

    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const dd = String(today.getDate()).padStart(2, "0");

    const formattedDate = `${yyyy}-${mm}-${dd}`;
    return formattedDate;
}

function getYesterdayDateYMD() {

    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    const yyyy = yesterday.getFullYear();
    const mm = String(yesterday.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const dd = String(yesterday.getDate()).padStart(2, "0");

    const formattedYesterday = `${yyyy}-${mm}-${dd}`;
    return formattedYesterday;
}

function getThisWeekRangeYMD() {

    const today = new Date();

    const yyyyToDay = today.getFullYear();
    const mmToDat = String(today.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const ddToDay = String(today.getDate()).padStart(2, "0");

    const formattedDate = `${yyyyToDay}-${mmToDat}-${ddToDay}`;

    const day = today.getDay();
    const diff = today.getDate() - day + (day === 0 ? -6 : 1); // adjust when Sunday (0)
    const firstDayOfWeek = new Date(today.setDate(diff));

    const yyyy = firstDayOfWeek.getFullYear();
    const mm = String(firstDayOfWeek.getMonth() + 1).padStart(2, "0");
    const dd = String(firstDayOfWeek.getDate()).padStart(2, "0");

    const formattedFirstDay = `${yyyy}-${mm}-${dd}`;

    return { startingDate: formattedFirstDay, endingDate: formattedDate };
}

function getLast7DaysRangeYMD() {

    const today = new Date();

    const yyyyToDay = today.getFullYear();
    const mmToDay = String(today.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const ddToDay = String(today.getDate()).padStart(2, "0");

    const formattedToDayDate = `${yyyyToDay}-${mmToDay}-${ddToDay}`;

    const prev7thDay = new Date(today);
    prev7thDay.setDate(today.getDate() - 7);

    const yyyy = prev7thDay.getFullYear();
    const mm = String(prev7thDay.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const dd = String(prev7thDay.getDate()).padStart(2, "0");

    const formattedPrev7thDay = `${yyyy}-${mm}-${dd}`;

    return { startingDate: formattedPrev7thDay, endingDate: formattedToDayDate };
}

function getThisMonthRangeYMD() {

    const today = new Date();

    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const dd = String(today.getDate()).padStart(2, "0");

    const formattedDate = `${yyyy}-${mm}-${dd}`;
    const formattedMonthFirstDate = `${yyyy}-${mm}-${"01"}`;

    return { startingDate: formattedMonthFirstDate, endingDate: formattedDate };
}

function getPreviousMonthRangeYMD(){

      const today = new Date();

      // Set date to the 0th day of the current month → last day of previous month
      const lastDayPrevMonth = new Date(
        today.getFullYear(),
        today.getMonth(),
        0
      );

      const yyyy = lastDayPrevMonth.getFullYear();
      const mm = String(lastDayPrevMonth.getMonth() + 1).padStart(2, "0");
      const dd = String(lastDayPrevMonth.getDate()).padStart(2, "0");

      const formattedLastDateOfPreviousMonth = `${yyyy}-${mm}-${dd}`;
      const formattedFirstDateOfPreviousMonth = `${yyyy}-${mm}-${"01"}`;

    return { startingDate: formattedFirstDateOfPreviousMonth, endingDate: formattedLastDateOfPreviousMonth };
}

function DMYFormateToYMDAndViseVersa(date){

  return date.split('-').reverse().join('-');
}

export {
    getTodayDateDMY,
    getFinancialYearDateDMY,
    getTodayDateYMD,
    getYesterdayDateYMD,
    getThisWeekRangeYMD,
    getLast7DaysRangeYMD,
    getThisMonthRangeYMD,
    getPreviousMonthRangeYMD,
    DMYFormateToYMDAndViseVersa
};